import React from 'react';
import { CodeExample } from '@cimpress/react-components';
import DemoDocsCode from '!raw-loader!./documentation.jsx';
import DemoDocs from './documentation.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const DocumentationDocs = () => {
  const codePropInfos = [
    {
      name: 'code',
      type: 'string (required)',
      default: '',
      description: 'The code to display, as a string.',
    },
    {
      name: 'initialOpen',
      type: 'boolean',
      default: 'true',
      description: 'Whether the code example should start open or collapsed.',
    },
  ];

  const propInfos = [
    {
      name: 'name',
      type: 'string (required)',
      default: '',
      description: 'The name of the component being documented.',
    },
    {
      name: 'demoName',
      type: 'string',
      default: 'Demo',
      description: 'Header for the code demo, if desired.',
    },
    {
      name: 'propInfos',
      type: 'array of {name: string, type: string, default: string, description: string}',
      default: '',
      description: <span>Array of objects representing prop info to document the props.</span>,
    },
    {
      name: 'remarks',
      type: 'element',
      default: '',
      description: 'Additional remarks or notes about the component',
    },
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'Children for the component doc -- usually a demo of the component and the code example',
    },
  ];

  return (
    <div>
      <ComponentDoc name="Documentation" />
      <ComponentDoc name="ComponentDoc" propInfos={propInfos} includeTabs={false} />
      <ComponentDoc name="CodeExample" propInfos={codePropInfos} includeTabs={false}>
        <DemoDocs />
        <CodeExample code={DemoDocsCode} />
      </ComponentDoc>
    </div>
  );
};

export default DocumentationDocs;
